// @flow
import fundItems from './fundItems';
import fundActivity from './fundActivity';


const filterId: 'fund' = 'fund';
export default filterId;

export { fundItems, fundActivity };
